import React from "react";
import JobDescriptionTextArea from "./JobDescriptionTextArea";

import { useJobDetails } from "@/context/JobDetailsContext";
import SkillDropdown from "./SkillsDrowpdown";




const AddJobDetails = () => {
	const { setJobDetails, jobDetails, setPrimaryRequirements, setSecondaryRequirements, primaryRequirements, secondaryRequirements } = useJobDetails();
	const experienceOptions = [
		"1–3 years",
		"3–5 years",
		"5–7 years",
		"7–10 years",
		"10+ years",
	];

	const handleSelectSkill = (skill: string, selectedSkills: string[], setSelectedSkills: React.Dispatch<React.SetStateAction<string[]>>) => {
		const normalizedSkill = skill.trim();
		if (
			normalizedSkill &&
			!selectedSkills.some((s) => s.toLowerCase() === normalizedSkill.toLowerCase())
		) {
			setSelectedSkills((prev) => [...prev, normalizedSkill]);
		}
	};

	const handleRemoveSkill = (skillToRemove: string, setSelectedSkills: React.Dispatch<React.SetStateAction<string[]>>) => {
		setSelectedSkills((prev) =>
			prev.filter(
				(skill) => skill.toLowerCase() !== skillToRemove.toLowerCase()
			)
		);
	};
	return (
		<div className="mt-6 max-w-7xl px-4 space-y-6">
			{/* Job Role */}
			<div>
				<label className="text-gray-600 text-sm font-medium mb-1 block">
					Job Role <span className="text-red-500">*</span>
				</label>
				<input
					required
					type="text"
					value={jobDetails?.title}
					onChange={(e) => setJobDetails({ ...jobDetails, title: e.target.value })}
					placeholder="Enter Job Role/Title"
					className="w-full px-4 py-2 border border-gray-300 rounded-lg "
				/>
			</div>

			{/* Years of Experience */}
			<div>
				<label className="text-gray-600 text-sm font-medium mb-2 block">
					Years of Experience Required
				</label>
				<div className="flex flex-wrap gap-3">
					{experienceOptions.map((option) => (
						<button
							key={option}
							onClick={() => {
								setJobDetails({ ...jobDetails, experience: option })
							}}
							type="button"
							className={`px-6 py-2.5 rounded-md  transition-all text-sm ${jobDetails?.experience === option
								? "bg-[#D1F6D7] border-green-300"
								: "bg-gray-100 border-gray-300"
								}`}
						>
							{option}
						</button>
					))}
				</div>
			</div>

			{/* Type, Location, Notice Period, Salary */}
			<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
				<div>
					<label className="text-gray-600 text-sm font-medium mb-1 block">
						Type
					</label>
					<select className="w-full p-2 border border-gray-300 rounded-lg  text-sm focus:outline-none" onChange={(e) => setJobDetails({ ...jobDetails, type: e.target.value })} value={jobDetails?.type}>
						<option value={""}>Select Work  Type</option>
						<option value={"Full-time"}>Full-time</option>
						<option value={"Part-time"}>Part-time</option>
						<option value={"Contract"}>Contract</option>
						<option value={"Internship"}>Internship</option>
						<option value={"Freelance"}>Freelance</option>
						<option value={"Temporary"}>Temporary</option>

					</select>
				</div>

				<div>
					<label className="text-gray-600 text-sm font-medium mb-1 block">
						Location
					</label>
					<input
						onChange={(e) => setJobDetails({ ...jobDetails, location: e.target.value })}
						value={jobDetails?.location}
						type="text"
						placeholder="Enter Location"
						className="w-full p-2 border border-gray-300 rounded-lg  text-sm focus:outline-none"
					/>
				</div>

				<div>
					<label className="text-gray-600 text-sm font-medium mb-1 block">
						Notice Period
					</label>
					<select className="w-full p-2 border border-gray-300 rounded-lg  text-sm focus:outline-none" onChange={(e) => setJobDetails({ ...jobDetails, noticePeriod: e.target.value })} value={jobDetails?.noticePeriod}>
						<option value={""}>Enter Notice Period</option>
						<option value={"Immediate"}>Immediate</option>
						<option value={"15 Days"}>15 Days</option>
						<option value={"30 Days"}>30 Days</option>
						<option value={"60 Days"}>60 Days</option>
						<option value={"90 Days"}>90 Days</option>
					</select>
				</div>

				<div>
					<label className="text-gray-600 text-sm font-medium mb-1 block">
						Salary
					</label>
					<div className="flex items-center gap-2">
						<select className="p-2 border border-gray-300 rounded-lg  text-sm" onChange={(e) => setJobDetails({ ...jobDetails, currency: e.target.value })} value={jobDetails?.currency}>
							<option value={"USD"}>USD</option>
							<option value={"EUR"}>EUR</option>
							<option value={"GBP"}>GBP</option>
							<option value={"INR"}>INR</option>
							<option value={"AUD"}>AUD</option>
							<option value={"CAD"}>CAD</option>
							<option value={"SGD"}>SGD</option>
						</select>
						<select className="p-2 border border-gray-300 rounded-lg  text-sm" onChange={(e) => setJobDetails({ ...jobDetails, salaryPer: e.target.value })} value={jobDetails?.salaryPer}>
							<option value={"Year"}>Year</option>
							<option value={"Month"}>Month</option>
						</select>
						<input
							onChange={(e) => setJobDetails({ ...jobDetails, salary: e.target.value })}
							value={jobDetails?.salary}
							type="text"
							placeholder="Enter Salary"
							className="flex-1 p-2 border border-gray-300 rounded-lg  text-sm focus:outline-none"
						/>
					</div>
				</div>
			</div>

			{/* Must Have & Good to Have Skills */}
			<div className="grid grid-cols-1 = gap-6">
				<div>
					<label className="text-gray-600 text-sm font-medium mb-1 block">
						Must Have Skills
					</label>
					<SkillDropdown onSelect={handleSelectSkill} skillSet={primaryRequirements} setSkillSet={setPrimaryRequirements} />

					<div className="relative mt-4  p-2 rounded-lg  min-h-16 max-h-40 overflow-y-auto bg-gray-50">
						<div className="flex flex-wrap gap-3 pr-10">
							{primaryRequirements.map((skill) => (
								<span
									key={skill}
									className="flex items-center gap-2 px-3 py-1.5 bg-green-100 text-green-800 rounded-full "
								>
									{skill}
									<button
										onClick={() => handleRemoveSkill(skill, setPrimaryRequirements)}
										className="text-green-800 hover:text-green-600 focus:outline-none"
										aria-label={`Remove ${skill}`}
									>
										×
									</button>
								</span>
							))}
						</div>

						{primaryRequirements.length > 0 ? (
							<button
								onClick={() => setPrimaryRequirements([])}
								className="absolute top-2 right-2 font-bold  text-gray-500 hover:text-red-500 transition"
								aria-label="Clear all skills"
							>
								×
							</button>
						) :
							<div className="text-gray-400 px-2 flex gap-3 flex-wrap items-center">
								Ex.
								<span

									className="flex items-center gap-2 px-3 py-1.5 bg-green-50 text-gray-400 rounded-full "
								>
									Sales
									<button
										disabled
										className="text-gray-400 "

									>
										×
									</button>
								</span>
								<span

									className="flex items-center gap-2 px-3 py-1.5 bg-green-50 text-gray-400 rounded-full "
								>
									Marketing
									<button
										disabled
										className="text-gray-400 "

									>
										×
									</button>
								</span>
								<span

									className="flex items-center gap-2 px-3 py-1.5 bg-green-50 text-gray-400 rounded-full "
								>
									Python
									<button
										disabled
										className="text-gray-400 "

									>
										×
									</button>
								</span>
								... etc.</div>}
					</div>

				</div>

				<div>
					<label className="text-gray-600 text-sm font-medium mb-1 block">
						Good to Have Skills
					</label>
					<SkillDropdown onSelect={handleSelectSkill} skillSet={secondaryRequirements} setSkillSet={setSecondaryRequirements} />

					<div className="relative mt-4  p-2 rounded-lg  min-h-16 max-h-40 overflow-y-auto  bg-gray-50">
						<div className="flex flex-wrap gap-3 pr-10">
							{secondaryRequirements.map((skill) => (
								<span
									key={skill}
									className="flex items-center gap-2 px-3 py-1.5 bg-green-100 text-green-800 rounded-full "
								>
									{skill}
									<button
										onClick={() => handleRemoveSkill(skill, setSecondaryRequirements)}
										className="text-green-800 hover:text-green-600 focus:outline-none"
										aria-label={`Remove ${skill}`}
									>
										×
									</button>
								</span>
							))}
						</div>

						{secondaryRequirements.length > 0 ? (
							<button
								onClick={() => setSecondaryRequirements([])}
								className="absolute top-2 right-2 font-bold  text-gray-500 hover:text-red-500 transition"
								aria-label="Clear all skills"
							>
								×
							</button>
						) :
							<div className="text-gray-400 px-2 flex gap-3 flex-wrap items-center">
								Ex.
								<span

									className="flex items-center gap-2 px-3 py-1.5 bg-green-50 text-gray-400 rounded-full "
								>
									Sales
									<button
										disabled
										className="text-gray-400 "

									>
										×
									</button>
								</span>
								<span

									className="flex items-center gap-2 px-3 py-1.5 bg-green-50 text-gray-400 rounded-full "
								>
									Marketing
									<button
										disabled
										className="text-gray-400 "

									>
										×
									</button>
								</span>
								<span

									className="flex items-center gap-2 px-3 py-1.5 bg-green-50 text-gray-400 rounded-full "
								>
									Python
									<button
										disabled
										className="text-gray-400 "

									>
										×
									</button>
								</span>
								... etc.</div>}
					</div>


				</div>
			</div>

			{/* Job Description */}


			<JobDescriptionTextArea

			/>

		</div>
	);
};

export default AddJobDetails;


